import { render, staticRenderFns } from "./newProductSale.vue?vue&type=template&id=4ca9009e&scoped=true&"
import script from "./newProductSale.vue?vue&type=script&lang=js&"
export * from "./newProductSale.vue?vue&type=script&lang=js&"
import style0 from "./newProductSale.vue?vue&type=style&index=0&id=4ca9009e&lang=scss&scoped=true&"
import style1 from "./newProductSale.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9009e",
  null
  
)

export default component.exports